import React from "react";
import styles from "./ResultCard.module.css";

const ResultCard = ({
  lotteryName,
  date,
  numberDigits = [],
  seriesDigits = [],
  logoUrl,
  onPlay,
}) => {
  return (
    <article className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.lotteryName}>{lotteryName}</h3>
        <p className={styles.date}>{date}</p>
      </div>

      <div className={styles.numbers}>
        <div className={styles.section}>
          <div className={styles.digits}>
            {numberDigits.map((d, i) => (
              <span key={i} className={styles.digit}>{d}</span>
            ))}
          </div>
          <span className={styles.label}>Número</span>
        </div>

        {seriesDigits.length > 0 && (
          <div className={styles.section}>
            <div className={styles.digits}>
              {seriesDigits.map((d, i) => (
                <span key={i} className={styles.digit}>{d}</span>
              ))}
            </div>
            <span className={styles.label}>Serie</span>
          </div>
        )}
      </div>

      <button className={styles.playBtn} onClick={() => onPlay?.()}>
        Jugar Ahora
      </button>
    </article>
  );
};

export default ResultCard;